import * as React from 'react';

import { ISuburbanInfoSchema } from '../../../types/results';
import { Text } from '../../Text';

export interface ISuburbanInfoProps {
  suburbanInfo: ISuburbanInfoSchema;
}

export function SuburbanInfo({ suburbanInfo }: ISuburbanInfoProps) {
  const { areaText, rentTypeText } = suburbanInfo;

  return areaText ? (
    <>
      {areaText && (
        <Text textSize="small" color="gray">
          {areaText}
        </Text>
      )}
      {rentTypeText && (
        <div>
          <Text textSize="small" color="gray">
            {rentTypeText}
          </Text>
        </div>
      )}
    </>
  ) : null;
}
